var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompanyIconGray = function SvgCompanyIconGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#697477",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.125 16.042h8.75m-8.75 0V4.792c0-.92.746-1.667 1.667-1.667h5.417c.92 0 1.666.746 1.666 1.667v1.875m-8.75 9.375H1.46m10.416 0V6.667m0 9.375h5m-5-9.375h3.334c.92 0 1.666.746 1.666 1.666v7.709m0 0h1.667m-10-8.75H6.459m0 3.333h2.083"
  })));
};
export { SvgCompanyIconGray as ReactComponent };
export default __webpack_public_path__ + "db2b4c4c3927cdc692f561b63c666739.svg";